import {Team} from '../../../teams/shared/model/team';

export interface TeamsState {
  teams: Team[];
}

export const initialTeamsState: TeamsState = {
  teams: null,
};
